import React, { useCallback, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Download } from '@mui/icons-material';
import { useCommonTranslation } from 'c-translation';
import type { FileBrowserFile } from './types';

type Props = {
    file: FileBrowserFile;
};

const OpenFileDownload: React.FC<Props> = ({ file }) => {
    const downloadable = useMemo(() => file?.urls?.download, [file]);
    const openInTabLabel = useCommonTranslation('FileBrowser.filePreview.download');

    const onClick = useCallback(e => {
        e.stopPropagation();
    }, []);

    return useMemo(
        () => (
            <>
                {downloadable && (
                    <Tooltip title={openInTabLabel}>
                        <IconButton target="_blank" href={downloadable} onClick={onClick}>
                            <Download />
                        </IconButton>
                    </Tooltip>
                )}
            </>
        ),
        [downloadable, onClick, openInTabLabel],
    );
};

export default OpenFileDownload;
